module.exports = __webpack_public_path__ + "static/media/qingping_plus@2x.9939fefc.png";